export default {
    name: 'registrant',
    serverName: '/api/v1/registrant/registrant/',
    apiUrl: '/api/v1/registrant/registrant/'
};
